module.exports = __webpack_public_path__ + "img/sodam_img02-1.0930bbc7.jpg";